import React from "react";
import { L10n } from "@fidget/common/i18n";
import styles from "./backLinkContainer.css";

interface Props {
  onClick: (ev: React.MouseEvent) => void;
}

export const BackLinkContainer: React.SFC<Props> = ({ onClick }) => {
  return (
    <div className={styles["back-link-container"]}>
      <button type="button" onClick={onClick} className={styles.button}>
        <L10n id={"signup.back"} />
      </button>
    </div>
  );
};
